import React, { Fragment, useEffect, useState } from 'react';
import { Select, Modal } from "antd";
import _ from "lodash";
import useRequest from '@/utils/useRequest';
const { Option } = Select;

const RoleSelect = ({ value,onChange }) => {
    const { request } = useRequest();
    const [rolelist, setRolelist] = useState([]);
    const [loading,setLoading] = useState(false);
    const getRoles = async () => {
        try {
          setLoading(true);
          let result = await request("/api/v2/private/role/search", "POST", "json", {
            pagination: {
              current: 1,
              pageSize: 1000
            },
            filters: {
            },
            sorter: null,
          });
          if (result.success) {
            setRolelist(result.data);
            if(onChange) onChange(result.data[0].Id)
          } else {
            Modal.error({ content: result.message });
          }
        } catch (err) {
          Modal.error({ content: err.message });
        }
        setLoading(false);
      }
      useEffect(()=>{
        getRoles();
      },[]);
    return (<div>
        <span>请选择角色：</span>
        <Select value={value} style={{ width: 120 }} onChange={(e) => {
          if(onChange) onChange(e);
        }}>
          {rolelist.map((item => {
            return <Option key={item.Id} value={item.Id} >{item.Name}</Option>
          }))}
        </Select>
      </div>)
}

export default RoleSelect;